import { Component, ComponentFactoryResolver, ComponentRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ComponentService, PaintService } from 'components';
import { ControllerSpecificationService } from 'src/app/services/controller-specification.service';

@Component({
  selector: 'app-assign-administrator',
  templateUrl: './assign-administrator.component.html',
  styleUrls: ['./assign-administrator.component.css']
})
export class AssignAdministratorComponent implements OnInit {

  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
  
  private componentRef: ComponentRef<any>;
  private resetPasswordViewCode : string = 'SG_VI04';

  constructor(private controllerSpecificationService: ControllerSpecificationService,
    private comp: ComponentFactoryResolver,
    private componentService: ComponentService, 
    private paintService: PaintService) { }

  public ngOnInit(): void {
    this.paintService.vViewComponents = this.controllerSpecificationService.getViews();
    this.loadComponent();
  }

  /**
   * This function loads the component based on the componentToLoad variable.
   */
  private loadComponent(): void {
    if (this.resetPasswordViewCode) {
      setTimeout(() => {
        this.changeView();
      });
    }
  }

  /**
  * This function changes the view by clearing the target view container and loading the appropriate component.
  */
  private changeView(): void {
    let component: any;
    component = this.controllerSpecificationService.getView(this.resetPasswordViewCode);
    this.target.clear();
    if (component === undefined) component = this.componentService.getComponent(this.resetPasswordViewCode);
    if (component !== undefined) {
      const componentFactory = this.comp.resolveComponentFactory(component);
      this.componentRef = this.target.createComponent(componentFactory);
      this.componentRef.changeDetectorRef.detectChanges();
    } 
  }
}
